// images only
export const IMAGE_FORMAT: Record<string, string[]> = {
    "image/png": [".png"],
    "image/jpeg": [".jpg", ".jpeg"],
};

/** Max file sizes matching the image upload advice shown in the CMS */
export const IMAGE_MAX_SIZE_200_KB = 200 * 1024;
export const IMAGE_MAX_SIZE_300_KB = 300 * 1024;
export const IMAGE_MAX_SIZE_1_MB = 1 * 1024 * 1024;
export const IMAGE_MAX_SIZE_4_MB = 4 * 1024 * 1024;
